angular.module('am4').filter('nameOrId', function() {
    return function(objArray, _needle) {
        var needle;
        if (_needle) {
            needle = _needle.toLowerCase();
            return objArray.filter(obj => typeof obj === 'object' &&
                (
                    obj.id.toString().toLowerCase().indexOf(needle) > -1 ||
                    (obj.name || '').toString().toLowerCase().indexOf(needle) > -1
                )
            );
        }

        return objArray;
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/nameOrId.js